import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

export const TextHeaderDe = () => {
    const isMobile = useMediaQuery('(max-width: 767px)')

    return (
        <HighlightedText
            text="DREHEN SIE DAS RAD UND ERHALTEN SIE FREISPIELE"
            highlights={[{ word: 'SIE FREISPIELE' }]}
            breakAfterWords={isMobile ? ['RAD', 'ERHALTEN'] : ['ERHALTEN']}
            className={styles.text_header}
        />
    )
}
